/* Chamak — scroll reveals. ~1KB, no dependencies.
   Elements are tagged from here rather than in the Liquid so that adding a
   section never means remembering to add an attribute. */
(function () {
  function start() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    /* [selector, stagger in ms between siblings] */
    var GROUPS = [
      ['.sec__head', 0],
      ['.hero__intro', 0],
      ['.finder', 0],
      ['.founders__body > *', 90],
      ['.crew__card', 70],
      ['.check__col', 120],
      ['.honest__panel', 0],
      ['.slot', 60],
      ['.promises li', 90],
      ['.lamhay__head', 0],
      ['.lam', 90],
      ['.fix', 45],
      ['.night__grid > *', 120],
      ['.area', 70],
      ['.qa', 45],
      ['.foot__top > *', 120]
    ];

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    GROUPS.forEach(function (g) {
      var nodes = document.querySelectorAll(g[0]);
      Array.prototype.forEach.call(nodes, function (el, i) {
        if (el.hasAttribute('data-reveal')) return;
        el.setAttribute('data-reveal', '');
        if (g[1]) el.style.setProperty('--d', Math.min(i * g[1], 420) + 'ms');
        io.observe(el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
